export default {
      id: "repeat.sprite-usage",
      viewBox: "0 0 14 12",
      url: __webpack_public_path__ + "sprite.svg#repeat.sprite-usage",
      toString: function () {
        return this.url;
      }
    }